import { FeatureTypes } from '@/components/Billing/billing-types';
export const ALL_PROJECTS_VIRTUAL_ID = 'everything';
export const ALL_PROJECTS_VIRTUAL_TITLE = 'Everything';
export const PROJECTS_SHARED_WITH_ME_VIRTUAL_ID = 'shared';
export const PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE = 'Shared with me';

export const PROJECTS_ENTITY = 'project';
export const PROJECTS_SENSITIVE_TYPE = 'sensitive';
export const PROJECTS_DEFAULT_TYPE = 'default';

export const PROJECTS_PERSONAL_ACCESS_TYPE = 'personal';
export const PROJECTS_WORKSPACE_ACCESS_TYPE = 'workspace';

export const VIRTUAL_PROJECT_IDS = [ALL_PROJECTS_VIRTUAL_ID, PROJECTS_SHARED_WITH_ME_VIRTUAL_ID];

// exported roles:

export const CAN_ANALYZE = 'analyst';
export const CAN_CONTRIBUTE = 'contributor';
export const CAN_COLLABORATE = 'editor';
export const ADMIN = 'admin';
export const REMOVE = '';

export const PROJECT_ROLES_ARR_BY_STRENGTH = [CAN_ANALYZE, CAN_CONTRIBUTE, CAN_COLLABORATE, ADMIN];

export const PROJECT_ROLES = {
	CAN_ANALYZE,
	CAN_CONTRIBUTE,
	CAN_COLLABORATE,
	ADMIN,
};

export const getOption = (value, text, subtext = '', billingFeatureId = null, disabled = false) => ({
	value,
	text,
	subtext,
	disabled,
	billingFeatureId,
});

export const REMOVE_ACTIONS = [{ divider: true }, getOption(REMOVE, 'Remove')];

export const FULL_ROLE_OPTIONS = [
	getOption(ADMIN, 'Space admin', 'Can edit assets, manage users and collaborators, and edit space settings'),

	getOption(
		CAN_COLLABORATE,
		'Space editor',
		'Can edit assets and manage users, cannot manage collaborators or space settings',
		FeatureTypes.CreatorSpacePermissions
	),
	getOption(
		CAN_CONTRIBUTE,
		'Space contributor',
		'Can edit drafts, but cannot publish or manage users',
		FeatureTypes.CreatorSpacePermissions
	),
	getOption(
		CAN_ANALYZE,
		'Space analyst',
		'Can see logs and create reports, has read-only access to features',
		FeatureTypes.CreatorSpacePermissions
	),
];

export const ROLE_MENU_OPTIONS = [...FULL_ROLE_OPTIONS, ...REMOVE_ACTIONS];

/* Descriptions */
const EDIT_FEATURES = 'edit and use features and connections';
const SENSITIVE_CONNECTIONS = 'manage sensitive connections';
const MANAGE_USERS = 'manage users';
const MANAGE_COLLABORATORS = 'manage collaborators';
const USE_FEATURE = 'manage who can use features';
const SEE_TASK_LOG = 'see task log';
const EDIT_PROJECT_SETTINGS = 'edit space settings';

export const PERMISSIONS_DESCRIPTIONS_MAP = {
	[ADMIN]: [EDIT_FEATURES, MANAGE_USERS, MANAGE_COLLABORATORS, USE_FEATURE, SENSITIVE_CONNECTIONS, EDIT_PROJECT_SETTINGS, SEE_TASK_LOG],
	[CAN_COLLABORATE]: [EDIT_FEATURES, MANAGE_USERS, USE_FEATURE, SEE_TASK_LOG],
	[CAN_CONTRIBUTE]: [EDIT_FEATURES, SEE_TASK_LOG],
	[CAN_ANALYZE]: [SEE_TASK_LOG],
};

export const ALL_PERMISSIONS = [
	EDIT_FEATURES,
	MANAGE_USERS,
	MANAGE_COLLABORATORS,
	USE_FEATURE,
	SENSITIVE_CONNECTIONS,
	EDIT_PROJECT_SETTINGS,
	SEE_TASK_LOG,
];

// SERVER STATE ACCORDING 22/06/2023 //

// class ProjectUserRoles(Enum):
//     can_analyze = [
//         ProjectPermissions.view_project,
//         ProjectPermissions.view_credentials,
//         ProjectPermissions.view_logs,
//     ]
//     can_contribute = [
//         ProjectPermissions.view_project,
//         ProjectPermissions.run_workflows,
//         ProjectPermissions.change_workflows,
//         ProjectPermissions.view_credentials,
//         ProjectPermissions.change_credentials,
//         ProjectPermissions.view_logs,
//     ]
//     can_edit_and_share = [
//         ProjectPermissions.view_project,
//         ProjectPermissions.run_workflows,
//         ProjectPermissions.change_workflows,
//         ProjectPermissions.publish_workflows,
//         ProjectPermissions.view_credentials,
//         ProjectPermissions.change_credentials,
//         ProjectPermissions.change_workflow_users,
//         ProjectPermissions.view_logs,
//     ]
//     admin = [
//         ProjectPermissions.view_project,
//         ProjectPermissions.change_project,
//         ProjectPermissions.delete_project,
//         ProjectPermissions.run_workflows,
//         ProjectPermissions.change_workflows,
//         ProjectPermissions.publish_workflows,
//         ProjectPermissions.view_credentials,
//         ProjectPermissions.change_credentials,
//         ProjectPermissions.view_sensitive_credentials,
//         ProjectPermissions.change_sensitive_credentials,
//         ProjectPermissions.change_workflow_users,
//         ProjectPermissions.change_project_users,
//         ProjectPermissions.view_settings,
//         ProjectPermissions.change_settings,
//         ProjectPermissions.view_logs,
//     ]
